
import { FactcheckSuggestion } from '@/types';
import { Component, Prop, VModel, Vue, Watch } from 'vue-property-decorator';
import * as FactcheckRequestServices from '@/services/FactCheckRequestServices';
import * as StorageServices from '@/services/StorageServices';

@Component
export default class NewFactcheckSuggestionDialog extends Vue {
    @VModel({ required: true }) show!: boolean;
    @Prop({default: []}) uniqueSources!: string[]

    dateMenu = false
    loading = false;

    date = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
    dateFormatted = this.formatDate(this.date)

    request: Partial<FactcheckSuggestion> = {
        claim: '',
        args: '',
        claimSource: '',
        email: '',
        whatsappCode: '',
        notes: '',
    };

    selectedSource = null as any

    search = ''
    tab = 0

    twitterLink = ''

    photo: File | null = null
    photoPreview = ''
    isDragActive = false

    sources = [
        {
            text: 'Twitter',
            value: 'twitter'
        },
        {
            text: 'Website',
            value: 'website'
        },
        {
            text: 'Email',
            value: 'email'
        },
        {
            text: 'Facebook',
            value: 'facebook'
        },
        {
            text: 'Instagram',
            value: 'instagram'
        },
        {
            text: 'TikTok',
            value: 'tiktok'
        },
        {
            text: 'WhatsApp',
            value: 'whatsapp'
        },
        {
            text: 'Andere',
            value: 'other'
        }
    ]

    get computedDateFormatted() {
        return this.formatDate(this.date);
    }

    @Watch('date')
    onDateChange() {
        this.dateFormatted = this.formatDate(this.date);
    }


    parseDate(date: string) {
        if (!date) return ''

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    }

    formatDate(date: string) {
        if (!date) return ''

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
    }

    setPhoto(file: File) {
        const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
        if (!allowedTypes.includes(file.type)) {
            return;
        }
        this.clearPhoto();
        this.photo = file;
        this.photoPreview = URL.createObjectURL(file);
    }

    onDrop(event: DragEvent) {
        this.isDragActive = false;
        const file = event.dataTransfer?.files?.[0];
        if (file) {
            this.setPhoto(file);
        }
    }

    onFileSelect(event: Event) {
        const input = event.target as HTMLInputElement;
        const file = input.files?.[0];
        if (file) {
            this.setPhoto(file);
        }
        input.value = '';
    }

    triggerFileInput() {
        const input = this.$refs.fileInput as HTMLInputElement;
        input?.click();
    }

    clearPhoto() {
        if (this.photoPreview) {
            URL.revokeObjectURL(this.photoPreview);
        }
        this.photo = null;
        this.photoPreview = '';
    }

    async addManualSuggestion() {
        this.loading = true;
        try {
            const created = await FactcheckRequestServices.CreateRequest({
                ...this.request,
                source: this.selectedSource.value,
                date: this.date,
            });
            if (this.photo && created?.id) {
                await StorageServices.UploadPhoto(`requests/${created.id}`, this.photo);
            }
            this.$emit('added');
            this.show = false;
        } finally {
            this.loading = false;
        }
    }

    async addTwitterSuggestion() {
        this.loading = true;
        if (this.twitterLink === '') {
            this.loading = false;
            return;
        }
        await FactcheckRequestServices.CreateRequestFromTweet(this.twitterLink);
        this.$emit('added');
        this.loading = false;
        this.show = false;
    }

    async addSuggestion() {
        if (this.tab === 0) {
            this.addManualSuggestion()
        } else {
            this.addTwitterSuggestion()
        }
    }

    @Watch('uniqueSources')
    onUniqueSourcesChange() {
        // add the sources that are not in the list
        this.uniqueSources.forEach(source => {
            if (!this.sources.find(s => s.value === source)) {
                this.sources.push({ text: source, value: source })
            }
        })
    }

    @Watch('show')
    onShowChange(val: boolean) {
        if (!val) {
            // reset all fields
            this.request = {
                claim: '',
                args: '',
                claimSource: '',
                email: '',
                whatsappCode: '',
                notes: '',
            };
            this.selectedSource = null
            this.date = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
            this.dateFormatted = this.formatDate(this.date)
            this.twitterLink = ''
            this.tab = 0
            this.clearPhoto()
            this.isDragActive = false
        }
    }

}
